import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { config } from "../../utils/config";
import { BasicTable } from '../../components/Table';
import { Paginated } from "../../components/Paginated";
import UserTemplate from "../../components/UserTemplate/UserTemplate";
import '../../components/table.css';
import styles from "../transaction/transaction.module.css"
import searchicon_black from "../../icons/searchicon_black.png"
import style from "../../components/Search&Options/Search&Options.module.css"
import CircularProgress from '@mui/material/CircularProgress';
import Sellerpagination from "../../components/Paginated/Sellerpagination";
import { Switch } from "antd";
const { apiEndpoint } = config;
var $ = require('jquery');

var count = 1;
const UserList = () => {
    const [userlist, setUserList]: any = useState<any[]>([]);
    const [userloading, setuserLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingUserId, setLoadingUserId] = useState<any>(null);
    const [sellerList, setSellerList]: any = useState<any[]>([]);
    const rawData = {
        seller_id: ''
    }
    const [searchData, setSearchData]: any = useState(rawData);
    const decode = tokenDecode();
    const { data } = decode;
    const permArray = Array.isArray(data?.permission)
        ? data.permission
        : Object.entries(data?.permission || {}).map(([tab_name, p]: any) => ({ tab_name, ...p }));
    const permissions = permArray.reduce((acc: any, item: any) => {
        if (item && item.tab_name) {
            acc[item.tab_name] = {
                read: item.p_read ?? item.read ?? true,
                write: item.p_write ?? item.write ?? true,
                update: item.p_update ?? item.update ?? true,
                delete: item.p_delete ?? item.delete ?? true,
            };
        }
        return acc;
    }, {});

    const user = permissions.user;
    const seller = permissions.seller;
    const role = permissions.role;
    const product = permissions.product;
    const order = permissions.order;

    const handleToggleUserStatus = async (userId: any, currentStatus: boolean) => {
        const newStatus = !currentStatus;
        setLoadingUserId(userId);

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/users/enable-disable/${userId}`,
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                    "Authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    status: newStatus,
                },
            });

            if (data?.status === true || data?.status === 200 || data?.success) {
                toast.success(data?.message || `User ${newStatus ? "activated" : "deactivated"} successfully!`);
                setUserList((prevList: any[]) =>
                    prevList.map((item: any) => {
                        const id = item?.id || item?.user_id;
                        if (id == userId) {
                            return {
                                ...item,
                                status: newStatus ? 1 : 0,
                            };
                        }
                        return item;
                    })
                );
            } else {
                toast.error(data?.message || "Failed to update user status.");
            }
        } catch (error: any) {
            console.error("Error updating user status:", error);
            toast.error(error?.response?.data?.message || error?.message || "Failed to update user status.");
        } finally {
            setLoadingUserId(null);
        }
    };


    const searchTimeoutRef = useRef<any>(null);

    const fetchUserList = async () => {
        try {
            setuserLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/users/getall`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            setuserLoading(false);
            if (data?.status === true || data?.status === 200) {
                const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data?.users) ? data.users : []);
                setUserList(list);
            } else {
                setUserList([]);
            }
        } catch (error) {
            console.log("Fetch user list error:", error);
            setuserLoading(false);
            setUserList([]);
        }
    };
    const userDelete = async (id: any) => {
        const confirm = window.confirm("Are you sure you want to delete this user?");
        if (!confirm) {
            return;
        }
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/users/delete/${id}`,
                method: "DELETE",
                headers: {
                    // "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
            });
            if (data?.status === true || data?.status === 200 || data?.success) {
                setUserList((prev: any[]) => prev.filter((item: any) => (item?.id || item?.user_id) !== id));
                toast.success(data?.message || "User deleted successfully!");
                fetchUserList();
                getSellerList();
            } else {
                toast.error(data?.message || "Failed to delete user!");
            }
        } catch (error: any) {
            console.error("Delete user error:", error);
            toast.error(error?.response?.data?.message || error?.message || "Failed to delete user!");
        }
    };
    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/users/getall`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            if (data.status) {
                // console.log(data.data)
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const inputHandler = async (e: any) => {
        try {

            var optionvalue = e.target.value;
            setSearchData({ ...searchData, [e.target.name]: e.target.value });
            // console.log(optionvalue);
            const { data } = await axios({
                url: `${apiEndpoint}/getuserfilterbyseller`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    seller_id: optionvalue
                }

            });

            if (data.status === 200) {
                // console.log(data);
                setUserList(data.data);
            }


        } catch (error) {
            console.log("error", error);
        }
    };
    const COLUMNS = [
        {
            Header: "#",
            Footer: "#",
            id: "index",
            Cell: ({ row }: any) => {
                return (
                    <span style={{ fontWeight: 600, color: "#64748B", fontSize: "13px" }}>
                        {(row?.index ?? 0) + 1}
                    </span>
                );
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "User Name",
            Footer: "User Name",
            id: "name",
            accessor: (row: any) => row?.name || "",
            Cell: ({ row }: any) => {
                const item = row?.original || row;
                const firstLetter = (item?.name || "U").charAt(0).toUpperCase();
                return (
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <div
                            style={{
                                width: "34px",
                                height: "34px",
                                borderRadius: "50%",
                                backgroundColor: "#EFF6FF",
                                color: "#1D4ED8",
                                border: "1px solid #BFDBFE",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 700,
                                fontSize: "14px",
                                flexShrink: 0
                            }}
                        >
                            {firstLetter}
                        </div>
                        <div>
                            <span style={{ fontWeight: 600, color: "#0F172A", fontSize: "13px" }}>
                                {item?.name || "N/A"}
                            </span>
                        </div>
                    </div>
                );
            },
            sticky: "left"
        },
        {
            Header: "Email",
            Footer: "Email",
            id: "email",
            accessor: (row: any) => row?.email || row?.display_email || "",
            Cell: ({ row }: any) => {
                const item = row?.original || row;
                return (
                    <div className="d-flex align-items-center" style={{ gap: "6px", color: "#334155", fontSize: "13px" }}>
                        <i className="far fa-envelope text-muted" style={{ fontSize: "12px" }}></i>
                        <span>{item?.email || item?.display_email || "N/A"}</span>
                    </div>
                );
            },
            sticky: "left"
        },
        {
            Header: "Contact",
            Footer: "Contact",
            id: "contact_no",
            accessor: (row: any) => row?.contact_no || "",
            Cell: ({ row }: any) => {
                const item = row?.original || row;
                return (
                    <div className="d-flex align-items-center" style={{ gap: "6px", color: "#334155", fontSize: "13px" }}>
                        <i className="fas fa-phone-alt text-muted" style={{ fontSize: "11px" }}></i>
                        <span>{item?.contact_no || "N/A"}</span>
                    </div>
                );
            },
            sticky: "left"
        },
        {
            Header: "Status",
            Footer: "Status",
            id: "status",
            accessor: (row: any) => row?.status,
            Cell: ({ row }: any) => {
                const item = row?.original || row;
                const isEnabled = Boolean(
                    item?.status === true ||
                    item?.status === 1 ||
                    item?.status === "1" ||
                    item?.status === "active" ||
                    item?.status === "ENABLE" ||
                    item?.status === "enable"
                );
                const userId = item?.id || item?.user_id;
                const isRowLoading = loadingUserId === userId;

                return (
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <Switch
                            checked={isEnabled}
                            loading={isRowLoading}
                            disabled={isRowLoading}
                            onChange={() => handleToggleUserStatus(userId, isEnabled)}
                            style={{
                                backgroundColor: isEnabled ? "#16A34A" : "#94A3B8"
                            }}
                        />
                        <span
                            style={{
                                backgroundColor: isEnabled ? "#DCFCE7" : "#F1F5F9",
                                color: isEnabled ? "#15803D" : "#64748B",
                                fontWeight: 600,
                                padding: "2px 8px",
                                borderRadius: "6px",
                                fontSize: "11px"
                            }}
                        >
                            {isEnabled ? "Active" : "Inactive"}
                        </span>
                    </div>
                );
            },
            sticky: "left"
        },
        {
            Header: "Action",
            Footer: "Action",
            id: "action",
            Cell: ({ row }: any) => {
                const item = row?.original || row;
                return (
                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                        {user.update ? (
                            <Link
                                to={`../../updateuser/${item?.id || item?.user_id}`}
                                className="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center"
                                style={{ borderRadius: "8px", width: "32px", height: "32px", padding: 0 }}
                                title="Edit User"
                            >
                                <i className="fas fa-pen" style={{ fontSize: "12px" }}></i>
                            </Link>
                        ) : null}
                        {user.delete ? (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger d-inline-flex align-items-center justify-content-center"
                                style={{ borderRadius: "8px", width: "32px", height: "32px", padding: 0 }}
                                onClick={() => userDelete(item?.id || item?.user_id)}
                                title="Delete User"
                            >
                                <i className="fas fa-trash-alt" style={{ fontSize: "12px" }}></i>
                            </button>
                        ) : null}
                    </div>
                );
            },
            sticky: "left"
        },
    ];
    count++
    useEffect(() => {
        fetchUserList();
        getSellerList();
    }, [])
    const [searchValue, setsearchValue] = useState("")

    const masterSearchHandler = (e: any) => {
        const searchedData = e.target.value.trimStart();
        const prevSearchValue = searchValue;
        setsearchValue(searchedData);

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        if (!searchedData.trim()) {
            if (prevSearchValue.trim() !== "") {
                fetchUserList();
            }
            return;
        }

        searchTimeoutRef.current = setTimeout(async () => {
            try {
                setuserLoading(true);
                const { data } = await axios.post(
                    `${apiEndpoint}/snp/users/search`,
                    { name: searchedData.trim() },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                            "Authorization": `Bearer ${sessionStorage.getItem("token")}`,
                        }
                    }
                );
                setuserLoading(false);
                if (data?.status === true || data?.status === 200 || data?.success) {
                    const list = Array.isArray(data?.data)
                        ? data.data
                        : (Array.isArray(data?.users)
                            ? data.users
                            : (Array.isArray(data?.result) ? data.result : []));
                    setUserList(list);
                } else {
                    setUserList([]);
                }
            } catch (err) {
                console.error("Search error:", err);
                setuserLoading(false);
                setUserList([]);
            }
        }, 300);
    };

    return (
        <ThemeMaker>
            <div className="container-fluid py-3 px-3">
                {/* Header Card */}
                <div
                    className="p-3 mb-3 bg-white border"
                    style={{
                        borderRadius: "12px",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                        position: "sticky",
                        top: "10px",
                        zIndex: 30
                    }}
                >
                    <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: "12px" }}>
                        <div>
                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                <h5 style={{ fontWeight: 700, color: "#0F172A", margin: 0 }}>
                                    User Management
                                </h5>
                                <span
                                    style={{
                                        backgroundColor: "#EFF6FF",
                                        color: "#1D4ED8",
                                        border: "1px solid #BFDBFE",
                                        borderRadius: "20px",
                                        padding: "2px 10px",
                                        fontSize: "12px",
                                        fontWeight: 600
                                    }}
                                >
                                    {userlist?.length || 0} Total
                                </span>
                            </div>
                            <span style={{ fontSize: "12px", color: "#64748B" }}>
                                Manage user accounts, status, and permissions
                            </span>
                        </div>

                        <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                            {/* Modern Search Bar */}
                            <div className="position-relative" style={{ minWidth: "260px" }}>
                                <i
                                    className="fas fa-search position-absolute"
                                    style={{
                                        left: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        color: "#94A3B8",
                                        fontSize: "13px"
                                    }}
                                ></i>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Search user by name..."
                                    className="form-control form-control-sm"
                                    style={{
                                        paddingLeft: "34px",
                                        paddingRight: searchValue ? "30px" : "12px",
                                        height: "38px",
                                        borderRadius: "10px",
                                        borderColor: "#CBD5E1",
                                        fontSize: "13px"
                                    }}
                                    value={searchValue}
                                    onChange={masterSearchHandler}
                                />
                                {searchValue && (
                                    <button
                                        type="button"
                                        className="btn btn-sm position-absolute border-0 p-0 text-muted"
                                        style={{ right: "10px", top: "50%", transform: "translateY(-50%)", background: "none" }}
                                        onClick={() => {
                                            setsearchValue("");
                                            fetchUserList();
                                        }}
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>

                            {/* Add User Button */}
                            {user?.write && (
                                <Link
                                    to="/adduser"
                                    className="btn btn-sm btn-primary d-flex align-items-center shadow-sm"
                                    style={{
                                        backgroundColor: "#105293",
                                        borderColor: "#105293",
                                        borderRadius: "10px",
                                        fontWeight: 600,
                                        height: "38px",
                                        padding: "0 18px",
                                        gap: "6px",
                                        fontSize: "13px"
                                    }}
                                >
                                    <i className="fas fa-plus"></i> Add User
                                </Link>
                            )}
                        </div>
                    </div>
                </div>

                {/* Table Container Card */}
                <div
                    className="bg-white border"
                    style={{
                        borderRadius: "12px",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                        overflow: "hidden",
                        minHeight: "60vh"
                    }}
                >
                    <div className="table-responsive">
                        {!userloading ? (
                            <Paginated data={userlist} columns={COLUMNS as any} emptyMessage={searchValue ? `No users matching "${searchValue}"` : "No users found"} />
                        ) : (
                            <div style={{ minHeight: "50vh", gap: "10px" }} className="d-flex flex-column align-items-center justify-content-center" >
                                <CircularProgress size={36} style={{ color: "#105293" }} />
                                <span style={{ fontSize: "13px", fontWeight: 600, color: "#64748B" }}>
                                    Loading users...
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ThemeMaker>
    );
}

export default UserList;